import { render, staticRenderFns } from "./FormExamDatabase.vue?vue&type=template&id=8135ccb8&"
import script from "./FormExamDatabase.vue?vue&type=script&lang=js&"
export * from "./FormExamDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports